import { RANDOM_ID } from '@app/constants/general.constants';

export const TRAVELER_STATIC_ID_PREFIX = 'TRAVELER';
export const DOCUMENT_TRAVELER_STATIC_ID_PREFIX = 'TRAVELER_ID';

export function travelerStaticId(): string {
  const sufix = Math.floor(Math.random() * RANDOM_ID);
  return `${TRAVELER_STATIC_ID_PREFIX}-${sufix}`;
}

export function travelerStaticDocumentId(): string {
  const sufix = Math.floor(Math.random() * RANDOM_ID);
  return `${DOCUMENT_TRAVELER_STATIC_ID_PREFIX}-${sufix}`;
}
